import AddNotesModal from './AddNotesModal';

export default AddNotesModal;
